import React, { FC, useCallback, useState } from 'react'
import { Grid, IconButton, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { get } from 'lodash'
import { getGeneralSettingsData } from '../../../../store/selectors'
import { icons } from '../../../../constants/icons'
import { GeneralCommissionFeeUpdateModal } from '../SettingGeneralModals'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    justifyContent: 'space-between',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    marginTop: theme.spacing(4),
    padding: theme.spacing(4),
  },
  sectionName: {
    fontWeight: 600,
    fontSize: 28,
    color: theme.palette.primary.light,
  },
  field: {
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.primary.light,
  },
  fieldTitle: {
    fontWeight: 500,
    fontSize: 20,
  },
  fieldContent: {
    fontSize: 16,
    wordWrap: 'break-word',
  },
  editIconGray: {
    color: '#a8a9ac',
    '&:hover': {
      color: theme.palette.primary.light,
    },
  },
}))

export const GeneralCommissionSettings: FC = () => {
  const classes = useStyles()
  const settings = useSelector(getGeneralSettingsData)
  const commissions = get(settings?.generalSettings, 'commission')

  const [isCommissionFeeModalOpen, setIsCommissionFeeModalOpen] = useState<boolean>(false)

  const handleUpdateCommissionFeeModal = useCallback(() => {
    setIsCommissionFeeModalOpen((prev) => !prev)
  }, [])

  return (
    <Grid container className={classes.container}>
      <Grid container item xs={12} gap={3}>
        {commissions && commissions.commissionFee !== null && (
          <Grid item xs={12} className={classes.field}>
            <Typography component="span" sx={{ mx: 1 }}>
              Commission rate:{' '}
            </Typography>
            <Typography component="span" sx={{ mx: 2 }}>{`${
              commissions.commissionFee !== null ? commissions.commissionFee : '-'
            }`}</Typography>
            <IconButton className={classes.editIconGray} onClick={handleUpdateCommissionFeeModal}>
              <span className="material-icons">{icons.EDIT}</span>
            </IconButton>
          </Grid>
        )}
      </Grid>
      <GeneralCommissionFeeUpdateModal
        isOpen={isCommissionFeeModalOpen}
        modalClose={handleUpdateCommissionFeeModal}
        defaultValue={commissions?.commissionFee}
      />
    </Grid>
  )
}
